import { query } from 'gql-query-builder'
import { map, pathOr, pipe, propOr } from 'ramda'

import StorefrontApi from '@/apis/storefront'

const BlogApis = {
  getAll: () =>
    StorefrontApi.request(
      query({
        operation: 'articles',
        variables: {
          first: 10,
          reverse: true,
        },
        fields: [
          {
            edges: [
              {
                node: [
                  'id',
                  'handle',
                  'title',
                  'excerpt',
                  { seo: ['title', 'description'] },
                  {
                    image: ['src'],
                  },
                  {
                    author: ['name'],
                  },
                ],
              },
            ],
          },
        ],
      }),
    ).then(pipe(pathOr([], ['articles', 'edges']), map(propOr({}, 'node')))),
  getPost: (handle) =>
    StorefrontApi.request(
      query({
        operation: 'blog',
        variables: {
          blogHandle: { name: 'handle', value: 'the-blog', required: true },
        },
        fields: [
          {
            operation: 'articleByHandle',
            variables: {
              handle: {
                value: handle,
                required: true,
              },
            },
            fields: [
              'id',
              'title',
              'contentHtml',
              { author: ['name'] },
              { image: ['src'] },
              { seo: ['title', 'description'] },
            ],
          },
        ],
      }),
    ).then(pipe(pathOr({}, ['blog', 'articleByHandle']))),
}

export default BlogApis
